export default "__VITE_ASSET__Dx$CnRpe__"